import { Content, Header, Page, SupportButton } from '@backstage/core-components';
import { Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

export function UptimePage() {
  return (
    <Page themeId="tool">
      <Header title="Uptime" subtitle="Service status powered by Checkly">
        <SupportButton />
      </Header>
      <Content>
        <Alert severity="info">
          This is a preview shell for the Checkly uptime dashboard. Phase 1 is behind the
          &quot;Uptime tab&quot; feature flag in your profile settings. The full status view
          will mirror{' '}
          <a href="https://status.inv.tech/?duration=1h" target="_blank" rel="noopener noreferrer">
            status.inv.tech
          </a>
          .
        </Alert>
        <Typography variant="body1" style={{ marginTop: 16 }}>
          Monitor configuration and Checkly integration will land in a follow-up change.
        </Typography>
      </Content>
    </Page>
  );
}
